/**
 * Synchrony Core Palette – JS export of design token values.
 *
 * These values mirror the SCSS `:export` block in synchrony-core-palette.scss.
 * In the Webpack build the css-loader ICSS mode turned the `:export` block into
 * JS named exports automatically; Vite does not do this for non-module SCSS
 * files, so we maintain the values here as plain JS constants.
 *
 * If a colour value changes, update both this file AND synchrony-core-palette.scss.
 */

// SYF Brand Vault Core Brand Colors
export const gold = "#feb600";
export const lightGold = "#fdbd15";
export const charcoalGray = "#3b3c43";
export const white = "#ffffff";
export const whiteSwitch = "#e0e0e0";
export const white12 = "rgba(255, 255, 255, 0.12)";
export const lightTurquise = "#acd3d7";
export const steelGray = "#94969a";
export const aliceBlue = "#eaeff2";

// SYF Brand Vault Supporting Colors
export const teal = "#34657f";
export const turquoise = "#58a7af";
export const darkGreen = "#3e8529";
export const lightGreen = "#9fc294";
export const fadedGreen = "#f0f6ef";

// SYF Brand Vault Accent Colors
export const brick = "#c63527";
export const lightBrick = "#e39a93";
export const fadedBrick = "#fcf4f3";
export const autumnOrange = "#d76b00";
export const lightGray = "#e9eaeb";
export const purple = "#84329b";
export const darkYellowWarning = "#caa416";
export const lightYellowWarning = "#fffaeb";

// Control Center Specific
export const marigold = "#fbc600";
export const mediumGreen = "#3e8529";
export const syfBackground = "#f8f8f8";
export const opacity87 = "rgba(0, 0, 0, 0.87)";
export const opacity38 = "rgba(0, 0, 0, 0.38)";
export const opacity19 = "rgba(0, 0, 0, 0.19)";
export const lightTeal = "#f0f3f5";
export const black = "#000000";
export const ccGold = "#fdbd17";
export const ccCharcoal = "#3c3d42";
export const ccLightGray = "#d0d0d0";
export const darkYellow = "#c1a42f";
export const gray83 = "#d4d4d4";
export const gray29 = "#4a4a4a";
export const ccYellow = "#f9c20a";
export const ccMediumGray = "#8e8e8e";
export const lightGreyDisabled = "#f6f6f6";
export const greyDisabledInput = "#eeeeee";
export const lightSilver = "#d8d8d8";
export const alternatingGradient =
  "repeating-linear-gradient(45deg, #ffffff, #ffffff 10px, #eeeeee 10px, #eeeeee 20px)";

// Default export with all values (for `import colors from ...` usage)
const palette = {
  gold,
  lightGold,
  charcoalGray,
  white,
  whiteSwitch,
  white12,
  lightTurquise,
  steelGray,
  aliceBlue,
  teal,
  turquoise,
  darkGreen,
  lightGreen,
  fadedGreen,
  brick,
  lightBrick,
  fadedBrick,
  autumnOrange,
  lightGray,
  purple,
  darkYellowWarning,
  lightYellowWarning,
  marigold,
  mediumGreen,
  syfBackground,
  opacity87,
  opacity38,
  opacity19,
  lightTeal,
  black,
  ccGold,
  ccCharcoal,
  ccLightGray,
  darkYellow,
  gray83,
  gray29,
  ccYellow,
  ccMediumGray,
  lightGreyDisabled,
  greyDisabledInput,
  lightSilver,
  alternatingGradient,
};

export default palette;
